import React, { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';
import { BackButton } from '../components/common/BackButton';
import { GuideCapture } from '../components/home/GuideCapture';

export function BookingThankYouPage() {
  useEffect(() => {
    // Store the Calendly URL
    const calendlyUrl = 'https://calendly.com/priorityai-info/ai-booking-demo';

    // Use setTimeout to ensure the component is fully mounted
    setTimeout(() => {
      // First attempt: Try window.open with fallback
      const newWindow = window.open(calendlyUrl, '_blank');
      
      if (newWindow === null) {
        // If popup blocked, use location.href
        window.location.href = calendlyUrl;
      }
    }, 0);
  }, []);

  return (
    <div className="min-h-screen pt-32 px-4">
      <div className="max-w-4xl mx-auto">
        <BackButton to="/" label="Back to Home" />
        
        <div className="bg-black/50 border border-green-500/20 rounded-lg p-8 text-center">
          <div className="flex justify-center mb-6">
            <CheckCircle className="w-16 h-16 text-green-500" />
          </div>
          
          <h1 className="text-3xl font-bold text-white mb-4">
            Thank you for scheduling your consultation!
          </h1>
          
          <p className="text-xl text-gray-300 mb-8">
            We look forward to discussing how we can help transform your business with AI solutions.
          </p>

          <div className="max-w-2xl mx-auto bg-black/30 border border-green-500/10 rounded-lg p-6">
            <h2 className="text-2xl font-bold text-white mb-4">
              While You Wait...
            </h2>
            
            <p className="text-gray-300 mb-6">
              Get our free guide to learn 4 simple steps that will help reduce your business costs and get back your valuable time.
            </p>
            
            <GuideCapture />
          </div>
        </div>
      </div>
    </div>
  );
}